import { ItiBaseEditor } from './../iti-base-editor';
import { Component, Model, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
    components: {
        ValidationProvider,
    },
})
export default class ItiDatePicker extends ItiBaseEditor {
    @Model('value-datepicker-change') public modelDate!: Date | null;

    public calendarVisible = false;

    public async changed(ev: Date | null) {
        this.$emit('value-datepicker-change', ev);
    }

    public get valueDate() {
        return this.modelDate;
    }

    public set valueDate(v: Date | null) {
        // ...
    }

}
